import { FocusEventHandler, ReactNode, useState } from "react";

import { ReactComponent as EyeSlashIcon } from "icons/eye-slash.svg";
import { ReactComponent as EyeIcon } from "icons/eye.svg";

import CustomInput from "./CustomInput";

type TextInputProps = {
  value: string;
  placeholder?: string;
  pattern?: string;
  onChange: any;
  onClear?: any;
  type?: "text" | "email" | "password" | "number" | "tel";
  onBlur?: FocusEventHandler<HTMLElement>;
  label?: string;
  id?: string;
  name?: string;
  autoComplete?: "on" | "off" | "new-password";
  error?: string;
  isClearable?: boolean;
  required?: boolean;
  disabled?: boolean;
  className?: string;
  button?: ReactNode;
  maxLength?: number;
  minLength?: number;
  spellCheck?: boolean;
  leadingContent?: ReactNode;
  min?: string | number;
  max?: string | number;
  showErrorText?: boolean;
  warning?: string | boolean;
};

const TextInput = ({
  value,
  placeholder,
  pattern,
  onChange,
  onClear,
  type,
  onBlur,
  label,
  id,
  name,
  autoComplete,
  error,
  required,
  disabled,
  className = "",
  button,
  maxLength,
  minLength,
  min,
  max,
  spellCheck = false,
  leadingContent,
  showErrorText = true,
  warning,
}: TextInputProps) => {
  const [showPassword, setShowPassword] = useState(false);
  const isPassword = type === "password";
  const inputType = isPassword
    ? showPassword
      ? "text"
      : "password"
    : type || "text";

  const hasValue = value !== null && value !== undefined && value !== "";

  return (
    <CustomInput
      id={id}
      label={label}
      error={error}
      warning={warning}
      onClear={hasValue && onClear}
      button={
        isPassword ? (
          <button
            className="CustomInput__password-eye"
            type="button"
            aria-label={showPassword ? "Hide password" : "Show password"}
            onClick={() => setShowPassword((v) => !v)}
          >
            {showPassword ? (
              <EyeSlashIcon title="hide password" />
            ) : (
              <EyeIcon title="show password" />
            )}
          </button>
        ) : (
          button || null
        )
      }
      leadingContent={leadingContent}
      showErrorText={showErrorText}
    >
      <input
        type={inputType}
        value={hasValue ? value : ""}
        placeholder={placeholder || ""}
        pattern={pattern}
        id={id}
        name={name}
        onChange={onChange}
        onBlur={onBlur}
        autoComplete={autoComplete || "on"}
        required={required}
        disabled={disabled || false}
        className={className}
        maxLength={maxLength}
        minLength={minLength}
        min={min}
        max={max}
        spellCheck={spellCheck}
      />
    </CustomInput>
  );
};

export default TextInput;
